import { makeAutoObservable } from 'mobx'
import type { PageLayoutStore } from 'shared/layout'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import type { CallModalStore } from 'widgets/CallModal'
import type { ContactsDetailsManageStore } from 'widgets/ContactsDetails/store'
import { ConversationMessagesStore } from 'widgets/ConversationMessages'
import { CallHistoryStore } from 'pages/conversations/pages/calls/ui/CallHistory'

export class CallsPageStore {
  private readonly _callHistoryStore: CallHistoryStore
  private readonly _conversationMessagesStore: ConversationMessagesStore

  constructor(
    private _pageLayoutStore: PageLayoutStore,
    private _callModalStore: CallModalStore,
    private _contactsDetailsManageStore: ContactsDetailsManageStore,
    private _entities: IEntitiesStore
  ) {
    this._callHistoryStore = new CallHistoryStore(
      this._callModalStore,
      this._contactsDetailsManageStore,
      this._pageLayoutStore,
      this._entities
    )
    this._conversationMessagesStore = new ConversationMessagesStore(
      this._entities,
      this._pageLayoutStore
    )

    makeAutoObservable(this)
  }

  get callStore() {
    return this._entities.callStore
  }

  get callHistoryStore() {
    return this._callHistoryStore
  }

  get conversationMessagesStore() {
    return this._conversationMessagesStore
  }
}
